import { CLIENTS_ACTIONS } from './clients.types'

/**
 * @param {import('./clients.types').ClientsSlice['status']} payload
 * @returns {import('./clients.types').ClientsStatusAction}
 */
export const setClientsStatusAction = payload => ({ type: CLIENTS_ACTIONS.SET_CLIENTS_STATUS, payload })

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./clients.types').ClientsErrorsAction}
 */
export const setClientsErrorsAction = payload => ({ type: CLIENTS_ACTIONS.SET_CLIENTS_ERRORS, payload })

/**
 * @param {import('./clients.types').ClientOption[]} payload
 * @returns {import('./clients.types').ClientOptionsAction}
 */
export const setClientOptionsAction = payload => ({ type: CLIENTS_ACTIONS.SET_CLIENT_OPTIONS, payload })
